// extracted by mini-css-extract-plugin
export default {"PanelHeader":"PanelHeader_PanelHeader__yNXf8"};